/**
 * Возможные виды действий, которые может выполнять BaseClickable
 */
export enum ActionKind {
  /** HTML Элемент button */
  button = 'button',

  /** HTML Элемент 'a' */
  anchor = 'a',

  /** BrowserRouter Link <Link /> */
  link = 'link',

  /** Все остальные HTML-элементы */
  defaultHtmlElement = 'defaultHtmlElement',
}
